import { useCallback } from "react";
import {
  useNavigate,
  useSearchParams,
  useParams,
  type NavigateOptions,
} from "react-router-dom";
import { useStore } from "../store/globalState";
import { useSessionStore } from "../store/useSessionStore";

/**
 * Navigation helper that preserves the linkId across routes (path param, query
 * param, global state or the claimed session) by appending `?linkId=...` to
 * the target route.
 */
export const useRouteWithToken = () => {
  const { linkId: linkIdFromParams } = useParams<{ linkId: string }>();
  const [searchParams] = useSearchParams();
  const { linkId: linkIdFromGlobalState } = useStore();
  const sessionLinkId = useSessionStore((s) => s.session.data?.linkId);

  const linkId =
    linkIdFromParams ||
    searchParams.get("linkId") ||
    linkIdFromGlobalState ||
    sessionLinkId;
  const navigate = useNavigate();

  const redirectTo = useCallback(
    (route: string, options?: NavigateOptions) => {
      if (linkId) {
        const connector = route.includes("?") ? "&" : "/?";
        navigate(`${route}${connector}linkId=${linkId}`, options);
      } else {
        navigate(route, options);
      }
    },
    [linkId, navigate]
  );

  return { redirectTo, linkId };
};
